import React from "react";

const Links = () => {
    const links = reactConfig.footerMenu;
    return (
        <div className="footer_links">
            <div className="footer_links_list">
                {links.map((link) => {
                    return (
                        <a
                            key={link.content}
                            href={link.href}
                            className="footer_links_list_link"
                        >
                            {link.content}
                        </a>
                    );
                })}
            </div>
        </div>
    );
};

export default Links;
